module.exports = __webpack_public_path__ + "static/media/triangle2.987b235b.svg";